class FooterNewsletter extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="email"]');
    this.button = this.querySelector('button[type="submit"]');
    this.message = this.querySelector('[data-newsletter-message]');
    if (!this.form || !this.input || !this.button || !this.message) return;

    this.form.addEventListener('submit', this.handleSubmit);
    this.configured = /^[a-zA-Z0-9]{6}$/.test(this.dataset.companyId || '') &&
      /^[a-zA-Z0-9]{6}$/.test(this.dataset.listId || '');
    this.input.disabled = !this.configured;
    this.button.disabled = !this.configured;
    this.form.removeAttribute('aria-busy');
    this.message.hidden = true;
    if (!this.configured) this.showMessage(this.dataset.unavailableMessage, 'alert');
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.handleSubmit);
    if (this.request) {
      clearTimeout(this.request.timeout);
      this.request.controller.abort();
      this.request = null;
    }
  }

  showMessage(text, role = 'status') {
    this.message.setAttribute('role', role);
    this.message.textContent = text;
    this.message.hidden = false;
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if (this.request || !this.configured || !this.form.reportValidity()) return;

    const request = {controller: new AbortController(), timedOut: false};
    this.request = request;
    this.input.disabled = true;
    this.button.disabled = true;
    this.form.setAttribute('aria-busy', 'true');
    this.showMessage(this.dataset.pendingMessage);
    request.timeout = setTimeout(() => {
      request.timedOut = true;
      request.controller.abort();
    }, 10000);

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.dataset.companyId)}`,
        {
          method: 'POST',
          credentials: 'omit',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            accept: 'application/vnd.api+json',
            revision: '2026-07-15',
          },
          signal: request.controller.signal,
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: this.dataset.source,
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: this.input.value.trim(),
                      properties: {$source: this.dataset.source},
                      subscriptions: {email: {marketing: {consent: 'SUBSCRIBED'}}},
                    },
                  },
                },
              },
              relationships: {list: {data: {type: 'list', id: this.dataset.listId}}},
            },
          }),
        },
      );
      if (this.request !== request) return;
      if (response.status !== 202) throw new Error('Subscription was not accepted');
      this.form.reset();
      this.showMessage(this.dataset.successMessage);
    } catch {
      if (this.request !== request) return;
      this.showMessage(request.timedOut ? this.dataset.timeoutMessage : this.dataset.errorMessage, 'alert');
    } finally {
      clearTimeout(request.timeout);
      if (this.request === request) {
        this.request = null;
        this.form.removeAttribute('aria-busy');
        this.input.disabled = false;
        this.button.disabled = false;
      }
    }
  };
}

if (!customElements.get('footer-newsletter')) {
  customElements.define('footer-newsletter', FooterNewsletter);
}
